import Uploads from './Uploads';
import UploadDetails from './UploadDetails';
import UploadsFilter from './UploadsFilter';

export default {
    Uploads,
    UploadDetails,
    UploadsFilter,
};
